import { render, staticRenderFns } from "./HSYFZD.vue?vue&type=template&id=20122cc6&scoped=true&"
import script from "./HSYFZD.vue?vue&type=script&lang=js&"
export * from "./HSYFZD.vue?vue&type=script&lang=js&"
import style0 from "./HSYFZD.vue?vue&type=style&index=0&id=20122cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20122cc6",
  null
  
)

export default component.exports